/**
 * Display formatting for decimal STRINGS (NF-04). Nothing here parses to a float and
 * nothing changes a stored value — it only decides how many of the stored digits are
 * worth printing.
 */

/** "13.0000" -> "13", "13.5000" -> "13.5", "1.2500" -> "1.25", "007.50" -> "7.5". */
export function trimDecimal(v: string): string {
  const negative = v.startsWith('-');
  const [rawWhole = '0', frac = ''] = (negative ? v.slice(1) : v).split('.');
  const whole = rawWhole.replace(/^0+(?=\d)/, '') || '0';
  const trimmed = frac.replace(/0+$/, '');
  const body = trimmed ? `${whole}.${trimmed}` : whole;
  return negative && body !== '0' ? `-${body}` : body;
}

/** A percentage held as a decimal string: "30.0000" -> "30%", "2.5000" -> "2.5%". */
export function pctText(v: string): string {
  return `${trimDecimal(v)}%`;
}
